import { useEffect } from "react";

const BASE_TITLE = "Drainage in Edinburgh | City Civils Construction LTD";
const META_DESCRIPTION =
  "Expert drainage in Edinburgh and Central Scotland — soakaways, surface water systems, blocked drain repairs and full drainage overhauls. Trusted by developers, homeowners and commercial clients across the Central Belt, City Civils delivers premium drainage, groundworks and landscaping done right the first time.";

/**
 * Sets the document title and meta description for SEO.
 * Pass a `suffix` for non-home pages (e.g. "About Us").
 */
export default function useSEO(suffix) {
  useEffect(() => {
    document.title = suffix ? `${BASE_TITLE} | ${suffix}` : BASE_TITLE;

    let descTag = document.querySelector('meta[name="description"]');
    if (!descTag) {
      descTag = document.createElement("meta");
      descTag.setAttribute("name", "description");
      document.head.appendChild(descTag);
    }
    descTag.setAttribute("content", META_DESCRIPTION);

    // Open Graph (better social sharing)
    const setMeta = (property, content) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };
    setMeta("og:title", document.title);
    setMeta("og:description", META_DESCRIPTION);
    setMeta("og:type", "website");
  }, [suffix]);
}
